import { v4 as uuid } from "uuid";
import { ElementState } from "@creatomate/preview";

import { getEffectColorsByOrg, getOrganizationDefaultFonts, getSubtitleDefaultPropertiesByOrg } from "components/stories/video-studio/utils";
import getLanguageDefaultFonts from "./getLanguageDefaultFonts";

const createSubtitleElement = (
  text: string,
  index: number,
  startTime: number,
  endTime: number,
  newTrack: number,
  organization: string,
  referenceId: string,
  language: string,
  element?: ElementState,
  burnSubtitles?: boolean,
  visible?: boolean
): Record<string, any> => {
  const organizationName = burnSubtitles ? (organization || "") : "";
  const fontProperties = getOrganizationDefaultFonts(organizationName, true, language);
  const fontEffectProperties = getEffectColorsByOrg("Rounded background", organizationName, true);
  const subtitleDefaultProperties = getSubtitleDefaultPropertiesByOrg(organizationName);

  const id = uuid();
  let subtitleProperties: Record<string, any> = {
    id,
    track: newTrack,
    type: "text",
    text,
    name: `sub-${index}-${language}-${id}-REF=${referenceId}`,
    time: startTime,
    dynamic: true,
    duration: endTime - startTime
  };

  // copy properties if another subtitle element
  if (element) {
    subtitleProperties = {
      ...element.source,
      ...subtitleProperties,
      visible: element.source.visible ?? visible
    };
  // if it is not a copy of a splitted element, we set the default values
  } else {
    subtitleProperties = {
      ...subtitleDefaultProperties,
      ...fontProperties,
      ...fontEffectProperties,
      ...subtitleProperties,
      visible
    };
  }

  if (language) {
    subtitleProperties = {
      ...subtitleProperties,
      ...getLanguageDefaultFonts(language, organization)
    };
  }

  return subtitleProperties;
};

export default createSubtitleElement;
